export const getFormData = (object: {[name: string]: string | Blob}) =>
  Object.entries(object).reduce((accumulator, [key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => accumulator.append(key, item));
    } else {
      accumulator.append(key, value);
    }
    return accumulator;
  }, new FormData());
